import { render, staticRenderFns } from "./ResellerTile.vue?vue&type=template&id=4b2c7543&scoped=true&"
import script from "./ResellerTile.vue?vue&type=script&lang=js&"
export * from "./ResellerTile.vue?vue&type=script&lang=js&"
import style0 from "./ResellerTile.vue?vue&type=style&index=0&id=4b2c7543&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c7543",
  null
  
)

export default component.exports